
<div class="page-title-area">
    <img src="assets/images/avsetup_banner_new.png" alt="Page Background" class="page-bg">
    <button class="back-arrow-btn" (click)="navigateToHome()">
        <i class="fas fa-chevron-left fa-2x"></i>
    </button>
    <div class="container">
        <div class="page-title-content">
            <h2>Audio & Video Solutions</h2>
        </div>
    </div>
</div>

<!-- <div class="main-banner-three">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6 col-md-12">
                <div class="main-banner-content">
                    <div class="d-table">
                        <div class="d-table-cell">
                            <div class="content">
                                <h1>Audio & Video SolutionsSecure IT Solutions For A More Secure Environment</h1>
                                <div class="slider-btn-wrap">
                                    <a routerLink="/about" class="box-btn border-btn">Know More</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 pr-0 col-md-12">
                <div class="banner-image-slider">
                    <img src="assets/images/avsetup_banner_new.png" alt="Page Background" class="page-bg">
                </div>
            </div>
        </div>
    </div>
</div> -->


<section class="services-details-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="section-title">
                    <h2>Audio & Video Solutions</h2>
                </div>
                <p>Designing audio and video solutions for boardrooms or classrooms requires a meticulous 
                approach to meet the critical expectations of customers.</p>
            </div>
        </div>

        <div class="scrives-item-2 mt-5">
            <div class="row align-items-center">
                <div class="col-12 col-md-6 d-flex justify-content-center align-items-center">
                    <div class="services-img mb-qc ios-content">
                        <div class="circular-layout">
                            <div class="image-container">
                              <img src="assets/images/AVsol2.jpeg" alt="image" class="image-container-img"/>
                            </div>
                          </div>
                        <!-- <div class="image-wrapper">
                            <div class="background-shape shape1"></div>
                            <div class="background-shape shape2"></div>
                            <img src="assets/images/solutions-details/53.png" alt="Audio Video Solutions">
                        </div> -->
                    </div>
                </div>

                <div class="col-lg-6">
                    
                    <h2>Steps for Setting Up a Meeting Room</h2>
                    <br>
                    
                    <div class="accordion-container">
                        <div class="accordion">
                            <div class="accordion-item">
                                <div class="accordion-header" (click)="toggleAccordion($event)">
                                    <h3>Analyse the Room Layout</h3>
                                    <i class="bx bx-chevron-down"></i>
                                </div>
                                <div class="accordion-content">
                                    <p>Evaluate the layout and size of the room to determine the optimal placement of display screens 
                                    and cameras. Ensure that every participant has a clear view from their position.</p>
                                </div>
                            </div>
                            
                            <div class="accordion-item">
                                <div class="accordion-header" (click)="toggleAccordion($event)">
                                    <h3>Device Compatibility</h3>
                                    <i class="bx bx-chevron-down"></i>
                                </div>
                                <div class="accordion-content">
                                    <p>Consider the types of devices the customer's team uses. Ensure seamless integration with existing 
                                    systems for smooth operations.</p>
                                </div>
                            </div>
                            
                            <div class="accordion-item">
                                <div class="accordion-header" (click)="toggleAccordion($event)">
                                    <h3>Select Technology</h3>
                                    <i class="bx bx-chevron-down"></i>
                                </div>
                                <div class="accordion-content">
                                    <p>Focus on reliability and high-quality output by choosing durable and advanced technology.</p>
                                </div>
                            </div>
                            
                            <div class="accordion-item">
                                <div class="accordion-header" (click)="toggleAccordion($event)">
                                    <h3>Include Touch Panels</h3>
                                    <i class="bx bx-chevron-down"></i>
                                </div>
                                <div class="accordion-content">
                                    <p>Install touch panels for easy control of all devices. This will simplify user interaction during 
                                    meetings or classes.</p>
                                </div>
                            </div>
                            
                            <div class="accordion-item">
                                <div class="accordion-header" (click)="toggleAccordion($event)">
                                    <h3>Assess Acoustics</h3>
                                    <i class="bx bx-chevron-down"></i>
                                </div>
                                <div class="accordion-content">
                                    <p>Evaluate the acoustics of the space. Choose the most effective audio systems and microphones to 
                                    ensure clarity and reduce noise interference.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="scrives-item-2 mt-4">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    
                    <!-- <h2>Additional Implementation Steps</h2>-->
                    <br> 
                    <br>
                    <br>
                    
                    <div class="accordion-container">
                        <div class="accordion">
                            <div class="accordion-item">
                                <div class="accordion-header" (click)="toggleAccordion($event)">
                                    <h3>Integrate Virtual Meeting Capabilities</h3>
                                    <i class="bx bx-chevron-down"></i>
                                </div>
                                <div class="accordion-content">
                                    <p>Incorporate capabilities for platforms like Zoom or Microsoft Teams. This supports effective remote 
                                    communication.</p>
                                </div>
                            </div>
                            
                            <div class="accordion-item">
                                <div class="accordion-header" (click)="toggleAccordion($event)">
                                    <h3>Ensure Flexibility and Scalability</h3>
                                    <i class="bx bx-chevron-down"></i>
                                </div>
                                <div class="accordion-content">
                                    <p>Ensure that the solution allows for future upgrades or expansions as the customer's needs evolve.</p>
                                </div>
                            </div>
                            
                            <div class="accordion-item">
                                <div class="accordion-header" (click)="toggleAccordion($event)">
                                    <h3>Provide Training Sessions</h3>
                                    <i class="bx bx-chevron-down"></i>
                                </div>
                                <div class="accordion-content">
                                    <p>Conduct training sessions to familiarise users with the new system. This will enhance user 
                                    confidence and efficiency.</p>
                                </div>
                            </div>
                            
                            <div class="accordion-item">
                                <div class="accordion-header" (click)="toggleAccordion($event)">
                                    <h3>Offer Support and Maintenance</h3>
                                    <i class="bx bx-chevron-down"></i>
                                </div>
                                <div class="accordion-content">
                                    <p>Provide continuous support and maintenance services to ensure the longevity and consistent 
                                    performance of the installed equipment.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-md-6 d-flex justify-content-center align-items-center">
                    <div class="services-img mb-qc ios-content">
                        <div class="circular-layout">
                            <div class="image-container">
                              <img src="assets/images/AVsol3.jpeg" alt="image" class="image-container-img"/>
                            </div>
                          </div>
                        <!-- <div class="image-wrapper">
                            <div class="background-shape shape1"></div>
                            <div class="background-shape shape2"></div>
                            <img src="assets/images/solutions-details/54.png" alt="Audio Video Implementation">
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<div class="container mb-4">
    <div class="d-flex justify-content-end">
        <button class="btn back-btn" (click)="navigateToHome()">
            <i class="fas fa-arrow-left me-2"></i> Back to Home
        </button>
    </div>
</div>
